import { Component } from '@angular/core';

import { ConfirmService } from '../../services/confirm.service';
import { AppButtonComponent } from '../button/app-button.component';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [AppButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  constructor(public confirm: ConfirmService) {}

  onConfirm() {
    this.confirm.close(true);
  }

  onCancel() {
    this.confirm.close(false);
  }
}
